import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DataService } from "src/app/shared/Services/data.service";


@Component({
  selector: 'app-category',
  templateUrl: './category.component.html',
  styleUrls: ['./category.component.scss']
})
export class CategoryComponent implements OnInit, OnDestroy {
  custId: string = '';
  breadCrumbItems: Array<{}> = [];
  private destroy$ = new Subject<void>();

  categoryTypes=['Logical','Event','Shedule','Userbased'];


  searchTerm: string = '';
  submitted: boolean = false;
  action: string = '';
  errmsg: string = '';
  categoryData: any[] = [];

  currentPage = 1;
  itemsPerPage = 3;
  pageSize = 0;

  delCategoryId: any = '';
  selectedCategory: any = null;

  categoryName: string = '';
  categoryType: string = '';
  isCategory: boolean = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private dataservice: DataService,
    private toastr: ToastrService
  ) {
    this.custId = this.route.snapshot.paramMap.get('id') || '';
  }

  ngOnInit(): void {
    this.breadCrumbItems = [
      { label: 'Configuration' },
      { label: 'Category' },
      { label: 'Formula', active: true },
    ];
    this.getData();
  }

  getData(): void {
    this.dataservice
      .get(`masterInterlock/config?custId=${this.custId}`)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res: any) => {
          this.categoryData = res['interlockConfiguration'];
        },
        (err) => {
          this.toastr.error('Server Unreachable');
          this.errmsg = 'Failed to load categories.';
        }
      );
  }

  goBack(): void {
    this.router.navigate(['/device', { id: this.custId }]);
  }

  openModal(content: any, data: any, act: string): void {
    this.action = act;
    this.submitted = false;

    if (act === 'Edit' && data) {
      this.selectedCategory = data;
      this.categoryName = data.categoryName;
      this.categoryType = data.categoryType;
      this.isCategory = data.isCategory;  
    } else {
      this.selectedCategory = null;
      this.categoryName = '';
      this.categoryType = '';
      this.isCategory = false;           
    }

    this.modalService.open(content, { backdrop: 'static', centered: true, size: 'lg' });
  }

  onPageChange(pageNum: number): void {
    this.pageSize = this.itemsPerPage * (pageNum - 1);
  }

  openModalDelete(deletetemp: any, data: any): void {
    this.delCategoryId = data.categoryId; 
    this.modalService.open(deletetemp, { backdrop: 'static', centered: true });
  }



  saveCategory(): void {
    this.submitted = true;
    if (!this.categoryName || !this.categoryType) return;

    if (this.action === 'Add') {
      const payload = {
        categoryName: this.categoryName,
        categoryType: this.categoryType,
        isCategory: this.isCategory,         
        custId: this.custId,
      };
      this.dataservice.post('masterInterlock/config', payload)
        .pipe(takeUntil(this.destroy$))
        .subscribe(
          () => {
            this.toastr.success('Category added successfully');
            this.modalService.dismissAll();
            this.getData();
          },
          (err) => this.toastr.error(err.message)

        );
    } else if (this.action === 'Edit') {
      const payload = {
        categoryName: this.categoryName,
        categoryType: this.categoryType,
        isCategory: this.isCategory,        
        custId: this.custId,
        categoryId:this.selectedCategory.categoryId
      };
      this.dataservice.put(`masterInterlock/config`, payload)
        .pipe(takeUntil(this.destroy$))
        .subscribe(
          () => {
            this.toastr.success('Category updated successfully');
            this.modalService.dismissAll();
            this.getData();
          },
          (err) => this.toastr.error(err.message)
        );
    }
  }

  delete(id: any): void {
    this.dataservice
      .delete(`masterInterlock/config?custId=${this.custId}&id=${id}`) 
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        () => {
          this.toastr.success('Category deleted successfully');
          this.modalService.dismissAll();
          this.getData();
        },
        (err) => this.toastr.error(err.message)
      );
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}